module.exports = __webpack_public_path__ + "static/img/gongzhonghao.96adea44.png";